import { SciChartSurface, SciChartDefaults } from 'scichart';

// One-time global SciChart runtime config shared by every chart: community
// license, CDN-streamed WASM, and a shared cache so surfaces reuse one WebGL
// context. Idempotent — safe to call from every SciChart view's init.
let configured = false;

export function ensureWasmConfigured(): void {
  if (configured) return;
  configured = true;
  // Turn on SciChart's license debug output so the community-license details
  // (including the build's ExpiryDate) print to the console. SciChart's license
  // validator reads this localStorage flag directly, so it must be set before
  // the first SciChartSurface.create(). Persists across reloads until cleared
  // via localStorage.removeItem('LICENSE_DEBUG').
  localStorage.setItem('LICENSE_DEBUG', '1');
  // eslint-disable-next-line new-cap
  SciChartSurface.UseCommunityLicense();
  SciChartSurface.loadWasmFromCDN();
  SciChartDefaults.useSharedCache = true;
}
